import React from "react";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";

import {Button, ButtonGroup} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import {Collections, Elements, Parts} from "components";
import PropTypes from "prop-types";
import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";
import moment from "moment";


/**
 *  @property {Transactions_Collections_Object|Transactions_Collections_Is} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
export default class Reservation extends TransactionObject {
	static propTypes = {
		...super.PropTypes,
		loadQuestions: PropTypes.func,
	};

	constructor(props) {
		super(props, Types.Transactions_Collections._name);
		this.read = 'GET_RESERVATION';
		this.update = typeof props.id !== 'undefined' && props.id ? 'POST_RESERVATION' : 'PUT_RESERVATION';
		this.delete = 'DELETE_RESERVATION';

		this.state.reserved_to = 'dealer';
		this.state.returned = false;

		this.afterCustomerSave = this.setNewObject('customer');
		this.afterDealerSave = this.setNewObject('dealer');
		this.afterLegalEntitySave = this.setNewObject('legal_entity', 'legal_entities');
		this.afterExportSave = this.setNewObject('exporter');
	}

	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		// noinspection JSValidateTypes
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey || prevState.binary_id === object.binary_id) {
			//Then check related props
			if (object.dealer !== prevState.dealer) {
				this.setState({
					'dealer_name_company': object.dealer ? object.dealers.name_display || object.dealers.name_trade || object.dealers.name_company : '',
					'dealer_ffl': object.dealer ? object.dealers.ffl : ''
				});
			}
			//If "Customer" select was updated, update corresponding Customer Information
			if (object.customers && object.customer !== prevState.customer && object.customers.customer_addressess) {
				this.setState({
					'customer_name_first': object.customer ? object.customers.name_first : '',
					'customer_name_middle': object.customer ? object.customers.name_middle : '',
					'customer_name_last': object.customer ? object.customers.name_last : '',
					'customer_name_suffix': object.customer ? object.customers.name_suffix : '',
					'customer_street_1': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_1 : '',
					'customer_street_2': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_2 : '',
					'customer_city': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].city : '',
					'customer_county': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].county : '',
					'customer_state': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].state : '',
					'customer_zip': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].zip : '',
				});
			}
		}
	}

	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Transactions_Collections_Object} data
	 */
	loadSelfAfter(data) {
		if (data.customer) {
			this.setState({'reserved_to': 'customer'});
		} else if (data.exporter) {
			this.setState({'reserved_to': 'exporter'});
		} else if (data.dealer) {
			this.setState({'reserved_to': 'dealer'});
		} else if (data.legal_entity) {
			this.setState({'reserved_to': 'legal_entity'});
		}

		// this.setState({'us_born': (!data.birth_country)});

		if (typeof this.props.updateData === 'function') {
			if (data.transaction_questionss.length > 0) {
				this.props.updateData(
					data.transaction_questionss.length > 0 ? data.transaction_questionss[0].pkey : null,
					data.transaction_questionss.length > 0 ? data.transaction_questionss[0].binary_id : null
				);
			}
		}

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(data.transaction || (data.binary_id + '-' + data.pkey));
		}
	};

	async handleSubmit(event, suppressToast = false) {
		this.state.products = this.state.transaction_entriess.map(entry => entry.products.pkey);
		await super.handleSubmit(event, suppressToast);
	};

	handleDealerClick = () => {
		this.setState({
			exporter: '',
			customer: '',
			legal_entity: '',
			reserved_to: 'dealer',
		});
	}

	handleCustomerClick = () => {
		this.setState({
			exporter: '',
			customer: '',
			legal_entity: '',
			reserved_to: 'customer',
		});
	}

	handleLegalEntityClick = () => {
		this.setState({
			exporter: '',
			customer: '',
			legal_entity: '',
			reserved_to: 'legal_entity',
		});
	}

	handleExporterClick = () => {
		this.setState({
			exporter: '',
			customer: '',
			legal_entity: '',
			reserved_to: 'exporter',
		});
	}

	form = () => {
		/** @type {Transactions_Collections_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						{/*#region Col 1*/}

						<div className={"col-md"}>

							{/*#region Details Section*/}

							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
							<div className={"form-group"}>
								<div className={"row"}>
									<div className={"col-md-3"}>
										<span className="input-label">Reserver</span>
									</div>
									<div className={"col-md-9 text-right"}>
										<ButtonGroup>
											<Button color={"primary"}
											        outline={this.state.reserved_to !== 'dealer'}
											        onClick={this.handleDealerClick}
											        active={this.state.reserved_to === 'dealer'}>Dealer</Button>
											<Button color={"primary"}
											        outline={this.state.reserved_to !== 'customer'}
											        onClick={this.handleCustomerClick}
											        active={this.state.reserved_to === 'customer'}>Customer</Button>
											<Button color={"primary"}
											        outline={this.state.reserved_to !== 'legal_entity'}
											        onClick={this.handleLegalEntityClick}
											        active={this.state.reserved_to === 'legal_entity'}>Trust / Legal Entity</Button>
											<Button color={"primary"}
											        outline={this.state.reserved_to !== 'exporter'}
											        onClick={this.handleExporterClick}
											        active={this.state.reserved_to === 'exporter'}>Exporter</Button>
										</ButtonGroup>
									</div>
								</div>
							</div>

							{this.state.reserved_to === 'dealer' &&
							<Parts.TransactionDealer
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterDealerSave={this.afterDealerSave}
								disableFields={true}
							/>}

							{this.state.reserved_to === 'customer' &&
							<Parts.TransactionCustomer
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								history={this.props.history}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterCustomerSave={this.afterCustomerSave}
								disableFields={true}
							/>}

							{this.state.reserved_to === 'legal_entity' &&
							<Parts.TransactionLegalEntity
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								history={this.props.history}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterLegalEntitySave={this.afterLegalEntitySave}
							/>}

							{this.state.reserved_to === 'exporter' &&
							<Parts.TransactionExport
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								history={this.props.history}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterExportSave={this.afterExportSave}
							/>}

							{/*#endregion*/}

							{/*#region (Form 4: 4a) Address of Maker, Manufacturer and/or Importer of Firearm Section*/}

							<h4 className="section-title">(Form 4: 4a) Address of Maker, Manufacturer and/or Importer of Firearm</h4>
							<div className={'form-group'}>
								<div className="row">
									<div className="col-6">
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Maker Street 1"}
												property={properties.maker_street_1}
												value={object.maker_street_1}
												error={object.maker_street_1_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className="col-6">
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Maker Street 2"}
												property={properties.maker_street_2}
												value={object.maker_street_2}
												error={object.maker_street_2_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className={"form-group"}>
								<div className={"row"}>
									<div className={"col-md-4"}>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Maker city"}
												property={properties.maker_city}
												value={object.maker_city}
												error={object.maker_city_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									<div className={"col-md-4"}>
										<div className="form-group">
											<Framework.Elements.Select
												shouldLoad={this.state.loaded}
												update={this.handleSelectPropertyUpdate}
												property={properties.maker_state}
												value={object.maker_state}
												error={object.maker_state_error}
												id={'short'}
												model={Types.States._name}
												nullable={true}
												limit={null}
											/>
										</div>
									</div>
									<div className={"col-md-4"}>
										<div className="form-group">
											<Framework.Elements.ZipCode
												label={"Maker ZIP"}
												property={properties.maker_zip}
												value={object.maker_zip}
												error={object.maker_zip_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
							</div>

							{/*#endregion*/}

							{/*#region Reservation Status Section*/}

							<h4 className="section-title">Reservation Status</h4>
							<div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Date</span>
									</div>
									<div className={'col-8'}>
										<div className="form-group">
											<Framework.Elements.Date
												property={properties.date}
												value={object.date}
												error={object.date_error}
												update={this.handleTextFieldPropertyUpdate}
												defaultValue={moment().format('YYYY-MM-DD')}
											/>
										</div>
									</div>
								</div>
							</div>
							{object.pkey &&
							<div>
								<div className={'row'}>
									<div className={'col-8'}>
										<span className="input-label">Returned</span>
									</div>
									<div className={'col-4 text-right'}>
										<div className={'form-group'}>
											<Framework.Elements.ButtonSwitch
												property={properties.returned}
												value={object.returned}
												error={object.returned_error}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={'Yes'}
												labelFalse={'No'}
											/>
										</div>
									</div>
								</div>
								{object.returned &&
								<div className="row">
									<div className="col-4">
										<span className="input-label">Returned Date</span>
									</div>
									<div className={'col-8'}>
										<div className="form-group">
											<Framework.Elements.DateTime
												property={properties.returned_date}
												value={object.returned_date}
												error={object.returned_date_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
								}
							</div>
							}
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Reservation Item(s) Notes"}
									property={properties.notes}
									value={object.notes}
									error={object.notes_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>

							{/*#endregion*/}

						</div>

						{/*#endregion*/}

						{/*#region Col 2*/}

						<div className={"col-md"}>

							{/*#region Items Section*/}

							<h4 className="section-title">
								Items
								<div className="pull-right">
									<Tooltip
										title="Products you have previously acquired and disposed / transferred can be found here."
										aria-label="Products you have previously acquired and disposed / transferred can be found here.">
										<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary" data-id={'quick-reservation-products'}>
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Items</span>
										</Button>
									</Tooltip>

									<UniversalModalOverride
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										name={"In Stock Products"}
										object={Collections.ProductsExisting}
										toggle={this.state.modalLookup}
										reportClose={this.handleReportProductClose}
										afterSave={this.addProducts}
										size={"xl"}
										status={"GET_IN_STOCK"}
										objectProps={{scannedCode: this.props.scannedCode}}
									/>

								</div>
							</h4>

							{object.transaction_entriess && object.transaction_entriess.map(
								(entry, i) =>
									<Elements.Item
										key={i}
										entry={entry}
										product={entry.products}
										onDelete={this.deleteProduct}
										onUpdate={this.updateProduct}
										openModal={this.handleToggleProductModel('productUpdate' + i)}
										reportClose={this.handleReportModalClose('productUpdate' + i)}
										modalUpdate={this.state['productUpdate' + i]}
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
									/>
							)}

							<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>

							{/*#endregion*/}

						</div>

						{/*#endregion*/}

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
